var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generate-test-paper"},[_c('generate-test-paper-data-table'),_c('generate-test-paper-setting',{attrs:{"exam-id":_vm.examId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }